import { render, staticRenderFns } from "./ResearchTree.vue?vue&type=template&id=1d17ebee"
import script from "./ResearchTree.vue?vue&type=script&lang=js"
export * from "./ResearchTree.vue?vue&type=script&lang=js"
import style0 from "./ResearchTree.vue?vue&type=style&index=0&id=1d17ebee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports